(function(EF) {
  var CourseSettingsService = require('services/course-settings-service');

  var Location = Chaplin.Model.extend({
  });

  _.extend(EF.Models, {
    Location: Location
  });
})(EF);
